export default __webpack_public_path__ + "static/media/PHQ-4.b65b5113.pdf";